"use strict";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const text_component_1 = require("../text/text.component");
const services_1 = require("../support/services");
/**
 * `Tab` component is a part of `TabBar` or `TabView` component.
 * `TabView` Tabs should be wrapped in `TabBar` or `TabView` to provide usable component.
 * See usage examples at `TabView` component documentation.
 *
 * @extends React.Component
 *
 * @property {string} title - Determines the title of the component.
 *
 * @property {StyleProp<TextStyle>} titleStyle - Determines style of the title.
 *
 * @property {ReactElement} children - Determines content of the tab.
 *
 * @property {(style: StyleType) => ReactElement} icon - Determines icon of the component.
 *
 * @property {boolean} selected - Determines tab selection state.
 *
 * @property {(selected: boolean) => void} onSelect = Fires on onSelect event.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example TabSimpleUsage
 *
 * @overview-example TabWithIcon
 *
 * @example TabWithExternalSourceIcon
 *
 * @example TabInlineStyling
 */
class TabComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.webEventResponder = services_1.WebEventResponder.create(this);
        this.onMouseEnter = () => {
            this.props.dispatch([theme_1.Interaction.HOVER]);
        };
        this.onMouseLeave = () => {
            this.props.dispatch([]);
        };
        this.onPress = () => {
            if (this.props.onSelect) {
                this.props.onSelect(!this.props.selected);
            }
        };
        this.getComponentStyle = (source) => {
            const { textMarginVertical, textFontFamily, textFontSize, textLineHeight, textFontWeight, textColor, iconWidth, iconHeight, iconMarginVertical, iconTintColor, ...containerParameters } = source;
            return {
                container: containerParameters,
                icon: {
                    width: iconWidth,
                    height: iconHeight,
                    marginVertical: iconMarginVertical,
                    tintColor: iconTintColor,
                },
                title: {
                    marginVertical: textMarginVertical,
                    fontFamily: textFontFamily,
                    fontSize: textFontSize,
                    lineHeight: textLineHeight,
                    fontWeight: textFontWeight,
                    color: textColor,
                },
            };
        };
        this.renderTitleElement = (style) => {
            const { title, titleStyle } = this.props;
            return (react_1.default.createElement(text_component_1.Text, { key: 1, style: [style, styles.title, titleStyle] }, title));
        };
        this.renderIconElement = (style) => {
            const iconElement = this.props.icon(style);
            return react_1.default.cloneElement(iconElement, {
                key: 2,
                style: [style, styles.icon, iconElement.props.style],
            });
        };
        this.renderComponentChildren = (style) => {
            const { title, icon } = this.props;
            return [
                icon && this.renderIconElement(style.icon),
                services_1.isValidString(title) && this.renderTitleElement(style.title),
            ];
        };
    }
    render() {
        const { themedStyle, style, ...derivedProps } = this.props;
        const { container, ...componentStyles } = this.getComponentStyle(themedStyle);
        const [iconElement, titleElement] = this.renderComponentChildren(componentStyles);
        return (react_1.default.createElement(react_native_1.TouchableOpacity, Object.assign({ activeOpacity: 1.0 }, derivedProps, this.webEventResponder.eventHandlers, { style: [container, styles.container, webStyles.container, style], onPress: this.onPress }),
            iconElement,
            titleElement));
    }
}
exports.TabComponent = TabComponent;
TabComponent.styledComponentName = 'Tab';
TabComponent.defaultProps = {
    selected: false,
};
const styles = react_native_1.StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {},
    title: {},
});
const webStyles = react_native_1.Platform.OS === 'web' && react_native_1.StyleSheet.create({
    container: {
        // @ts-ignore
        outlineWidth: 0,
    },
});
exports.Tab = theme_1.styled(TabComponent);
//# sourceMappingURL=tab.component.js.map